<template>
  <div class="buy-tour-step-1-1">
    <a-button class="btn-lotteries" @click="showModal()">Loterias</a-button>
    <a-modal
      v-if="open"
      :loading="true"
      class="lottery-list-current"
      style="height: 450px"
      v-model="open"
      @ok="handleOk()"
      @cancel="handleCancel()"
      :cancelText="'Cancelar'"
      :okText="'Aceptar'"
      title="Seleccionar Loterías"
    >
      <a-spin :spinning="loading" tip="Cargando...">
        <div v-if="selectedLotteries?.length" class="selected-lotteries">
          {{ selectedLotteryNames }}
        </div>
        <perfect-scrollbar
          :options="{ wheelPropagation: false, suppressScrollX: true }"
          style="height: 450px"
        >
          <div v-if="!loading" class="scroll-content">
            <div class="list-container">
              <div
                v-for="(lottery, key) in lotteries"
                :key="key"
                class="list-container-item"
                :class="{
                  selected: isSelected(lottery),
                }"
              >
                <div
                  v-if="lottery"
                  class="lottery-result-list-item"
                  @click="selectLottery(lottery)"
                >
                  <span class="lottery-result-list-item-details-logo">
                    <img
                      v-if="lottery.logo"
                      :src="lottery.logo"
                      :alt="lottery.name"
                      @error="lottery.logo = null"
                      style="object-fit: cover; width: 100%"
                    />
                  </span>
                  <div class="lottery-result-list-item-details-name">
                    {{ lottery.name }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </perfect-scrollbar>
      </a-spin>
    </a-modal>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { GET_LOTTERIES } from "@/utils/actions";
import { cloneDeep } from "lodash";
export default {
  props: {
    value: {
      type: [String, Object, Array],
      default: undefined,
    },
  },
  data() {
    return {
      open: false,
      loading: false,
      lotteries: [],
      selectedLotteries: [...this.value],
    };
  },
  computed: {
    selectedLotteryNames() {
      return this.selectedLotteries.map((item) => item.name).join(", ");
    },
  },
  methods: {
    ...mapActions("buy", ["fetchLotteries", "processTicket"]),
    isSelected(lottery) {
      return this.selectedLotteries.some((item) => item.id === lottery.id);
    },
    async showModal() {
      this.$emit("input", []);
      this.$store.commit("lotteries/" + GET_LOTTERIES, []);
      this.open = true;
      this.loading = true;
      try {
        let response = await this.fetchLotteries();
        this.lotteries = response.data.data;
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
        this.selectedLotteries = [...this.value];
        this.lotteries.forEach((element) => {
          let isSelected = this.selectedLotteries.find(
            (item) => item.id === element.id
          );
          if (isSelected) {
            element.disabled = true;
          }
        });
      }
    },
    selectLottery(lottery) {
      const tempLottery = cloneDeep(this.selectedLotteries);
      const found = tempLottery.find((item) => item.id === lottery.id);
      if (!found) {
        this.selectedLotteries.push(lottery);
      } else {
        let deselectLotteryIndex = this.selectedLotteries.findIndex(
          (item) => item.id === lottery.id
        );
        if (deselectLotteryIndex !== -1) {
          this.selectedLotteries.splice(deselectLotteryIndex, 1);
        }
      }
    },
    handleOk() {
      this.$emit("setSuperPale", false);
      this.$emit("input", this.selectedLotteries);

      this.$store.commit("lotteries/" + GET_LOTTERIES, this.selectedLotteries);
      this.open = false;
    },
    handleCancel() {
      this.open = false;
    },
  },
};
</script>
<style lang="scss">
@import "~@/assets/scss/variable";
.btn-lotteries {
  background: var(--btn-bg-secondary);
  color: var(--btn-text-secondary);
  border: 1px solid var(--btn-bc-secondary);
  border-radius: 0;
  &:hover,
  &:focus {
    background: var(--btn-bg-secondary);
    color: var(--btn-text-secondary);
    border: 1px solid var(--btn-bc-secondary);
  }
}

.list-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 16px;
  @media screen and (max-width: $screen-mobile) {
    gap: 18px 16px;
  }
  &-item {
    width: 48%;
    border: 1px solid var(--results-item-bc);
    border-radius: 0.45rem;
    padding: 10px;
    cursor: pointer;
    &.selected {
      border-color: var(--text-active);
    }
    @media screen and (max-width: $screen-mobile) {
      width: calc(48% - 2px);
    }
  }
}

.lottery-list-current {
  .selected-lotteries {
    margin: 0 20px;
    width: calc(100% - 40px);
    padding: 5px;
    border-radius: 5px;
    border: 1px solid var(--text-muted);
  }
  .scroll-content {
    width: 100%;
    padding: 20px;
  }
  .ant-modal-content {
    background-color: var(--modal-bg) !important;
    color: var(--text);
    .ant-modal-body {
      padding: 6px;
    }
  }

  .ant-modal-header {
    background: var(--modal-bg);

    .ant-modal-title {
      color: var(--text);
    }
  }

  .ant-modal-close-x {
    .anticon {
      color: var(--text) !important;
    }
  }

  .ant-modal-footer {
    .ant-btn {
      background: var(--btn-bg-secondary);
      color: var(--btn-text-secondary);
      border: 1px solid var(--btn-bc-secondary);

      &-primary {
        background: var(--btn-bg-primary);
        color: var(--btn-text-primary);
        border: 1px solid var(--btn-bc-primary);
      }
    }
  }

  &-item {
    .ant-card-body {
      padding: 0;
    }
    background-color: var(--results-item-bg);
    border-color: var(--results-item-bc);
    box-shadow: 0 1px 0.125rem var(--results-item-shadow);
    padding: 0;
    border-radius: 0.45rem;
    &-numbers {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 10px;
      background: var(--primary);
      background: var(--results-item-gradient);
      border-radius: 0 0.45rem 0.45rem 0;
      height: 100px;
      @media screen and (max-width: $screen-mobile) {
        width: 100%;
        border-radius: 0 0 0.45rem 0.45rem;
      }
      span {
        font-family: "Exo 2", sans-serif;
        font-weight: 400;
        margin: 0;
        line-height: 1.3;
        font-size: 1rem;
        text-align: center;
        color: var(--text);
        font-size: 1.2rem;
        padding: 8px;
        background-color: var(--results-item-number);
        border-radius: 0.85rem;
        width: 39.81px;
      }
    }
    &-details {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: row;
      gap: 10px;
      padding: 0 10px 0px 30px;
      color: var(--text);
      @media screen and (max-width: $screen-mobile) {
        flex-direction: column;
      }
      &-logo {
        width: 235px;
        padding-right: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        @media screen and (max-width: $screen-mobile) {
          width: 130px;
          height: 90px;
          padding-right: 0;
        }
        img {
          width: 100%;
        }
      }
      &-name {
        width: 410px;
        @media screen and (max-width: $screen-mobile) {
          width: 100%;
          text-align: center;
        }
        p,
        h2 {
          margin-bottom: 0;
        }
        h2 {
          color: var(--text-active);
          font-size: 1.15rem;
          @media screen and (max-width: $screen-mobile) {
            font-size: 1.5rem;
          }
        }
      }
      &-date {
        text-align: right;
        width: 100%;
        @media screen and (max-width: $screen-mobile) {
          text-align: center;
          margin-bottom: 10px;
        }
        label {
          color: var(--text-active);
        }
        p {
          margin-bottom: 0;
        }
      }
    }
  }
}
</style>
